"use client"

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { Progress } from "@/components/ui/progress"
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from 'recharts'
import type { QuestionState } from "@/lib/types"

interface CoverageStats {
    unseen: number;
    mastered: number;
    weak: number;
    volatile: number;
    critical: number;
    total: number;
    coveragePercentage: number;
}

interface CoverageChartProps {
    stats: CoverageStats;
}

const COLORS = {
    unseen: '#E5E7EB', // Gray-200
    mastered: '#22C55E', // Green-500
    weak: '#F59E0B', // Amber-500
    volatile: '#3B82F6', // Blue-500
    critical: '#EF4444', // Red-500
};

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }: any) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    if (percent < 0.05) return null; // Don't show label for small segments

    return (
        <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
            {`${(percent * 100).toFixed(0)}%`}
        </text>
    );
};

export function CoverageChart({ stats }: CoverageChartProps) {
    const data = [
        { name: 'No Vistas', value: stats.unseen, color: COLORS.unseen },
        { name: 'Dominadas', value: stats.mastered, color: COLORS.mastered },
        { name: 'Débiles', value: stats.weak, color: COLORS.weak },
        { name: 'Volátiles', value: stats.volatile, color: COLORS.volatile },
        { name: 'Críticas', value: stats.critical, color: COLORS.critical },
    ].filter(d => d.value > 0);

    return (
        <Card className="col-span-1">
            <CardHeader>
                <CardTitle className="text-lg font-semibold flex justify-between items-center">
                    <span>Cobertura del Temario</span>
                    <span className="text-sm font-normal text-muted-foreground">{stats.coveragePercentage.toFixed(1)}% Visto</span>
                </CardTitle>
            </CardHeader>
            <CardContent>
                <div className="h-[250px] w-full">
                    <ResponsiveContainer width="100%" height="100%">
                        <PieChart>
                            <Pie
                                data={data}
                                cx="50%"
                                cy="50%"
                                labelLine={false}
                                // label={renderCustomizedLabel}
                                outerRadius={80}
                                fill="#8884d8"
                                dataKey="value"
                            >
                                {data.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={entry.color} />
                                ))}
                            </Pie>
                            <Tooltip />
                            <Legend />
                        </PieChart>
                    </ResponsiveContainer>
                </div>
                <div className="mt-4 space-y-2">
                    <div className="text-sm text-center text-muted-foreground">
                        Total Preguntas: <span className="font-medium text-foreground">{stats.total}</span>
                    </div>
                </div>
            </CardContent>
        </Card>
    )
}
